// Function to dynamically load globals into webpack's manifest
var path = require('path');

function camelize(str) {
  return str.replace(/(\-\w)/g, function(m){return m[1].toUpperCase();});
}

function buildKey(file) {
  return file.charAt(0).toUpperCase() + camelize(file).slice(1).split('.')[0];
}

function importAll (r) {
  r.keys().forEach(function(key) {
    let file_name = key.split('/').pop();
    Kadenze[buildKey(file_name)] = r(key).default;
  });
}

importAll(require.context('./libs/globals', false, /\.js$/));
